import animateScrollTo from 'animated-scroll-to';
import { useEffect, useState } from 'react';
import { useGetParams } from './useGetParams';

export const useScrollText = (
  contentRef,
  contentContainerRef,
  message,
  setDelay,
  isCurrent,
) => {
  const { scrollSpeed, scrollDelayStart, scrollDelayEnd, duration } =
    useGetParams();

  const [isScaleEnd, setIsScaleEnd] = useState(false);

  useEffect(() => {
    const idTimer = setTimeout(() => {
      setIsScaleEnd(true);
    }, 1540);

    return () => {
      clearTimeout(idTimer);
    };
  }, []);

  useEffect(() => {
    if (
      !contentRef.current ||
      !contentContainerRef.current ||
      !isCurrent ||
      !isScaleEnd
    )
      return;
    if (
      contentRef.current.getBoundingClientRect().height -
        contentContainerRef.current.getBoundingClientRect().height >=
      10
    ) {
      // высота всего контента
      const height = contentRef.current.getBoundingClientRect().height;

      const elementToScroll = contentContainerRef.current;

      // lineHeightInit - высота контейнера в котором идет прокрутка, остаются видимы 3 строки после прокрутки текста
      const lineHeightInit = elementToScroll.getBoundingClientRect().height;

      // скорость скрола в пикселей/милисекунда
      const speedPxPerMs = scrollSpeed / 1000;

      // длительность прокрутки
      const linearAnimationDuration = Math.ceil(
        (height - lineHeightInit) / speedPxPerMs,
      );
      // задержка перед сменой сообщения
      const delayInterval =
        scrollDelayStart + linearAnimationDuration + scrollDelayEnd;

      setDelay(delayInterval);

      setTimeout(() => {
        animateScrollTo([0, height], {
          elementToScroll,
          minDuration: linearAnimationDuration,
          maxDuration: linearAnimationDuration,
          easing: (t) => {
            return t;
          },
        });
      }, scrollDelayStart);
    } else {
      // если не нужна прокрутка, дефолтная длительность показа сообщения
      setDelay(duration);
    }
  }, [
    message,
    scrollSpeed,
    duration,
    contentRef,
    contentContainerRef,
    //
    scrollDelayStart,
    scrollDelayEnd,
    setDelay,
    isCurrent,
    isScaleEnd,
  ]);
};
